import { MarkerClusterer, SuperClusterAlgorithm } from "@googlemaps/markerclusterer";
import { viewport, getBlogId, isBlogId } from '../functions';

var map;
var markerhover = [];
var ms = [];
const params = new URL(document.location.toString()).searchParams;
const location = params.get('oflocations');
var defaultZoom = 12;

const MarkerIcon = (color) => window.btoa(`
  <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
    <circle cx="120" cy="120" opacity="1" r="70" />
    <circle cx="120" cy="120" opacity=".5" r="90" />
    <circle cx="120" cy="120" opacity=".2" r="110" />
  </svg>`);

var styles = {
    hide: [
        {
            featureType: 'road',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }]
        },
        {
            featureType: 'landscape',
            elementType: 'labels',
            stylers: [
                { visibility: 'off' }
            ]
        },
        {
            featureType: 'administrative',
            elementType: 'labels',
            stylers: [
                { visibility: 'off' }
            ]
        },
        {
            featureType: 'poi.business',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }]
        },
        {
            featureType: 'transit',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'off' }]
        }
    ]
};

function getClusterById(map, id) {
    if(!map?.markerCluster?.clusters) return null;
    return map.markerCluster.clusters.find((c) => typeof c.markers.find((m) => m.id === id) !== 'undefined');
}

function hasGreenPin(ids) {
    let has = false;
    for (let i = 0; i <= ids.length - 1; i += 1) {
        if (window.statuses[ids[i]] === 'green') {
            has = true;
            break;
        }
    }
    return has;
}

function hasOrangePin(ids) {
    let has = false;
    for (let i = 0; i <= ids.length - 1; i += 1) {
        if (window.statuses[ids[i]] === 'orange') {
            has = true;
            break;
        }
    }
    return has;
}

function showme(id) {
    ms[id]['oldzindex'] = ms[id].getZIndex();
    ms[id].setZIndex(1001);

    let scaledSize = new google.maps.Size(36, 51);
    if (isBlogId(1))
        scaledSize = ['green', 'orange'].includes(window.statuses[id]) ? new google.maps.Size(36, 51) : new google.maps.Size(29, 52)

    let icon = {
        url: window[window.statuses[id] + '_marker'],
        scaledSize
    }
    ms[id].setIcon(icon);
}

function showold(id) {
    if (typeof ms[id] == 'undefined')
        return;

    ms[id].setZIndex(ms[id]['oldzindex']);

    let scaledSize = new google.maps.Size(30, 40);
    if (isBlogId(1))
        scaledSize = ['green', 'orange'].includes(window.statuses[id]) ? new google.maps.Size(28, 40) : new google.maps.Size(22, 40)

    let icon = {
        url: window[window.statuses[id] + '_marker'],
        scaledSize
    }
    ms[id].setIcon(icon);
}

function getClusterColor(clusterMarkers) {
    let color = isBlogId(1) ? '#949494' : '#637381';
    if (hasGreenPin(clusterMarkers.map((m) => m.id)))
        color = isBlogId(1) ? '#08867B' : '#1BC47D';
    if (hasOrangePin(clusterMarkers.map((m) => m.id)))
        color = isBlogId(1) ? '#FF5401' : '#FE621D'; 
    return color;
}

function centerByAddress(map, address) {
    let geocoder = new google.maps.Geocoder()

    geocoder.geocode({ 'address': address }, function (results, status) {

        if (status == google.maps.GeocoderStatus.OK) {
            let LatLng = {
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng()
            }
            map.setCenter(new google.maps.LatLng(LatLng.lat, LatLng.lng))
        }
    });
}

function initMap($el) {
    if (typeof $el !== 'object' || typeof $el.jquery === 'undefined') return;

    var $markers = $el.find('.marker');
    let map;

    const mapArgs = {
            zoom: defaultZoom,
            maxZoom: 17,
            minZoom: 11,
            navigationControl: true,
            scaleControl: true,
            scrollwheel: false,
            draggable: true,
            mapId: '1d3f1e39ac49d742',
            zoomControl: true,
            mapTypeControl: viewport().width >= 768,
            zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT,
            }
        };
    
    if($markers.length < 1)
        mapArgs.center = new google.maps.LatLng(49.8149618, 5.8531474);    

        map = new google.maps.Map($el[0], mapArgs);
        map.setOptions({ styles: styles['hide'] });

        map.markers = [];
        if ($markers.length > 0) {
            $markers.each(function () {
                initMarker($(this), map);
            });
        }

        const render = ({ count, position, markers }, stats) => {
            const color = getClusterColor(markers);
            return new google.maps.Marker({
                position,
                icon: {
                    url: `data:image/svg+xml;base64,${MarkerIcon(color)}`,
                    scaledSize: new google.maps.Size(45, 45),
                },
                label: {
                    text: String(count),
                    color: "rgba(255,255,255,0.9)",
                    fontSize: "12px",
                },
                title: `Cluster of ${count} markers`,
                // adjust zIndex to be above other markers
                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
            });
        }

        var markerCluster = new MarkerClusterer({
            map,
            markers: map.markers,
            algorithm: new SuperClusterAlgorithm({
                gridSize: 60,
                radius: 100,
                maxZoom: 16,
            }),
            renderer: { render },
            // onClusterClick: (ev, cluster, map) => {
            //     create_popup(map, cluster.marker, cluster.markers.map((v) => v.id))
            // }
        });

        map.markerCluster = markerCluster;

        google.maps.event.addDomListener(window, 'load', initMap)

    if ($markers.length > 0) {
        centerMap(map);
    } else {
        centerByAddress(map, $('.acf-map')[0].getAttribute('address'))
    }

    mapInit();

    $(document).on('mapResize', function (e) {
        google.maps.event.trigger(map, 'center_changed');
    });

    return map;
}


function initMarker($marker, map) {

    var lat = $marker.data('lat');
    lat = lat ? lat.toString().replace(',', '.') : lat;

    var lng = $marker.data('lng');
    lng = lng ? lng.toString().replace(',', '.') : lng;

    if (lat === '' || lng === '' || isNaN(lat) || isNaN(lng))
        return;

    let id = $marker.attr('id');

    var latLng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
    };

    let zindex = ['green', 'orange'].includes(window.statuses[id]) ? 1000 : null;
    let scaledSize = new google.maps.Size(30, 40)
    if (isBlogId(1))
        scaledSize = ['green', 'orange'].includes(window.statuses[id]) ? new google.maps.Size(28, 40) : new google.maps.Size(22, 40)

    var marker = new google.maps.Marker({
        position: latLng,
        icon: {
            url: window[window.statuses[id] + '_marker'],
            scaledSize
        },
        map: map,
        ...(zindex ? { zIndex: zindex } : {}),
    });
    marker.id = id;

    markerhover.push(marker);

    map.infoWindow = false;
    map.markers.push(marker);

    ms[id] = marker;


    google.maps.event.addListener(marker, 'click', function () {
        create_popup(map, marker, [marker.id]);
    });
}

export function updateMarkers($markers) {
    // Remove all old markers from map and arrays
    if (map && map.markers) {
        map.markers.forEach(marker => {
            if (marker) {
                marker.setMap(null);
            }
        });
        map.markers = [];
    }
    markerhover = [];
    ms = [];

    // Add new markers
    $markers.each(function () {
        initMarker($(this), map);
    });

    // Refresh marker clusterer if present
    if (map && map.markerCluster) {
        map.markerCluster.clearMarkers();
        map.markerCluster.addMarkers(map.markers);
    }

    // Recenter map
    if ($markers.length > 0) {
        centerMap(map);
    } else {
        centerByAddress(map, $('.acf-map')[0].getAttribute('address'))
    }
}

function centerMap(map) {
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    if (map.markers.length == 1) {
        map.setCenter(bounds.getCenter());
        map.setZoom(defaultZoom);
    } else {
        const isLocationSelected = $('body').hasClass('tax-locations') || location;
        map.setOptions({ maxZoom: isLocationSelected ? 13 : 16, minZoom: 10 });
        map.fitBounds(bounds);

        setTimeout(function () {
            map.setOptions({ maxZoom: 17, minZoom: 11 });
        }, 1000);
    }
}

function getGap() {
    if(viewport().width >= 1600) {
        return 32;
    }

    return 16;
}

function get_mapTop() {
    return jQuery('.rooms-container').offset().top - jQuery('#main-header').outerHeight();
}

function get_mapLeft() {
    return jQuery('.roomlist').offset().left + jQuery('.roomlist').width() + getGap();
}

function get_mapRight() {
    let $container = jQuery('.mapright').parent();
    return jQuery(window).width() - ($container.offset().left + $container.width());
}

function get_mapWidth() {
    return jQuery('.mapright').parent().width() - jQuery('.roomlist').width() - getGap();
}

function get_mapHeight() {
    return viewport().height - jQuery('#main-header').outerHeight();
}

function setPopupRoom(infoWindow, id) {
    let form_data = [];
    form_data.push({ name: 'id', value: id });
    form_data.push({ name: 'blog-id', value: getBlogId() });
    form_data.push({ name: 'action', value: 'marker_content' });

    $.ajax({
        type: 'post',
        url: theme.ajaxurl,
        dataType: 'json',
        data: form_data,
        beforeSend: function () {
        },
        success: function (response) {
            const $infoWindow = $(infoWindow.getContent());
            $infoWindow.find('.infoWindow__content').html(response.html);
            infoWindow.setContent($($('<div></div>').html($infoWindow)).html());

            setTimeout(function () {
                $('button.gm-ui-hover-effect').on('click', function () {
                    $('.marker-content').css('opacity', '0');
                });

                let owl = $('.customer-logos');
                owl.on('initialized.owl.carousel', function (event) {
                    $('.marker-content').css('display', 'block');
                })
                owl.owlCarousel({
                    items: 1,
                    loop: true,
                    margin: 0,
                    dots: false,
                    navText: [
                        '<button type=\"button\" role=\"presentation\" class=\"owl-prev\"><img src="/wp-content/uploads/2015/05/arrow_left.png"></button>',
                        '<button type=\"button\" role=\"presentation\" class=\"owl-next\"><img src="/wp-content/uploads/2015/05/arrow_right.png"></button>'
                    ]
                });
                setTimeout(function () {
                    $('.marker-content').animate({ opacity: 1 }, 300);
                }, 200);


            }, 200);
        },
        error: function (response) {
            console.log(response);
        },
        complete: function () {
        }
    });
}


function setPopupPagination(infoWindow, ids, cIndex = 0) {
    const count = 6;
    const cPage = Math.floor(cIndex / count) + 1;
    const pages = Math.floor((ids.length - 1) / count) + 1;
    const hasPrev = cPage > 1;
    const hasNext = pages > cPage;
    const liClass = 'text-center py-2 border-t border-r border-solid border-gray-200 last:border-r-none';
    const liClassEnabled = `${liClass} cursor-pointer`;
    let html = '<ul class="infoWindow__pagination absolute bottom-0 left-0 w-full grid grid-cols-8 z-10">';
    if (ids.length > 1) {
        html += `<li class="prev ${hasPrev ? `enabled ${liClassEnabled}` : liClass}" data-id="${ids[(cPage - 1) * count - 1]}" data-index="${(cPage - 1) * count - 1}">${hasPrev ? '...' : ''}</li>`;
        for (let i = 1; i <= count; i += 1) {
            const index = (cPage - 1) * count + i;
            if (ids.length < index) {
                html += `<li class="${liClass}"></li>`;
            } else {
                html += `<li class="link ${index - 1 == cIndex ? 'bg-green text-white' : ''} ${liClassEnabled}" data-id="${ids[index - 1]}" data-index="${index - 1}">${index}</li>`;
            }
        }
        html += `<li class="next ${hasNext ? `enabled ${liClassEnabled}` : liClass}" data-id="${ids[cPage * count]}" data-index="${cPage * count}">${hasNext ? '...' : ''}</li>`;
    }
    html += '</ul>';

    const $infoWindow = $(infoWindow.getContent());
    $infoWindow.find('.infoWindow__pagination').html(html);
    infoWindow.setContent($($('<div></div>').html($infoWindow)).html());
}

function setPopupLoading(infoWindow) {
    const html = '<div class="infoWindow__content">\n' +
        '<div class="absolute top-0 left-0 w-full h-full flex justify-center items-center">\n' +
        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;" width="80px" height="80px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">\n' +
        '<g transform="rotate(0 50 50)">\n' +
        '  <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#bbbbbb">\n' +
        '    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.9166666666666666s" repeatCount="indefinite"/>\n' +
        '  </rect>\n' +
        '</g><g transform="rotate(30 50 50)">\n' +
        '  <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#bbbbbb">\n' +
        '    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.8333333333333334s" repeatCount="indefinite"/>\n' +
        '  </rect>\n' +
        '</g><g transform="rotate(60 50 50)">\n' +
        '  <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#bbbbbb">\n' +
        '    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite"/>\n' +
        '  </rect>\n' +
        '</g><g transform="rotate(90 50 50)">\n' +
        '  <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#bbbbbb">\n' +
        '    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.6666666666666666s" repeatCount="indefinite"/>\n' +
        '  </rect>\n' +
        '</g><g transform="rotate(120 50 50)">\n' +
        '  <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#bbbbbb">\n' +
        '    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5833333333333334s" repeatCount="indefinite"/>\n' +
        '  </rect>\n' +
        '</g><g transform="rotate(150 50 50)">\n' +
        '  <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#bbbbbb">\n' +
        '    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite"/>\n' +
        '  </rect>\n' +
        '</g><g transform="rotate(180 50 50)">\n' +
        '  <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#bbbbbb">\n' +
        '    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.4166666666666667s" repeatCount="indefinite"/>\n' +
        '  </rect>\n' +
        '</g><g transform="rotate(210 50 50)">\n' +
        '  <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#bbbbbb">\n' +
        '    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.3333333333333333s" repeatCount="indefinite"/>\n' +
        '  </rect>\n' +
        '</g><g transform="rotate(240 50 50)">\n' +
        '  <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#bbbbbb">\n' +
        '    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite"/>\n' +
        '  </rect>\n' +
        '</g><g transform="rotate(270 50 50)">\n' +
        '  <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#bbbbbb">\n' +
        '    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.16666666666666666s" repeatCount="indefinite"/>\n' +
        '  </rect>\n' +
        '</g><g transform="rotate(300 50 50)">\n' +
        '  <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#bbbbbb">\n' +
        '    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.08333333333333333s" repeatCount="indefinite"/>\n' +
        '  </rect>\n' +
        '</g><g transform="rotate(330 50 50)">\n' +
        '  <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#bbbbbb">\n' +
        '    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"/>\n' +
        '  </rect>\n' +
        '</g>\n' +
        '<!-- [ldio] generated by https://loading.io/ --></svg>\n' +
        '</div>\n' +
        '</div>';

    const $infoWindow = $(infoWindow.getContent());
    $infoWindow.find('.infoWindow__content').html(html);
    infoWindow.setContent($($('<div></div>').html($infoWindow)).html());
}

function create_popup(map, marker, ids, id = null) {
    if (!id) id = ids[0];

    if (map.infoWindow)
        map.infoWindow.close();

    const content = '<div class="infoWindow">\n' +
        '<div class="infoWindow__content">\n' +
        '</div>\n' +
        '<div class="infoWindow__pagination">\n' +
        '</div>\n' +
        '</div>';

    let infoWindow = new google.maps.InfoWindow({
        content: content,
    });

    map.infoWindow = infoWindow;

    setPopupLoading(infoWindow);
    const cIndex = ids.indexOf(id)
    setPopupPagination(infoWindow, ids, cIndex);

    google.maps.event.addListener(infoWindow, 'domready', function () {
        const events = ['click', 'zoom_changed'];
        events.forEach((ev) => {
            google.maps.event.addListener(map, ev, function () {
                $('.marker-content').css('opacity', '0');
                if (map.infoWindow)
                    map.infoWindow.close();
            });
        });

        google.maps.event.addListener(infoWindow, 'closeclick', function () {
            $('.marker-content').css('opacity', '0');
        });

        $('.infoWindow__pagination .prev.enabled').click(function () {
            setPopupLoading(infoWindow);
            setPopupPagination(infoWindow, ids, $(this).attr('data-index'));
            setPopupRoom(infoWindow, $(this).attr('data-id'));
        });

        $('.infoWindow__pagination .next.enabled').click(function () {
            setPopupLoading(infoWindow);
            setPopupPagination(infoWindow, ids, $(this).attr('data-index'));
            setPopupRoom(infoWindow, $(this).attr('data-id'));
        });

        $('.infoWindow__pagination .link').click(function () {
            setPopupLoading(infoWindow);
            setPopupPagination(infoWindow, ids, $(this).attr('data-index'));
            setPopupRoom(infoWindow, $(this).attr('data-id'));
        });
    });

    infoWindow.open(map, marker);

    setPopupRoom(infoWindow, id);
}

function mapPositioning() {
    const map = jQuery('.mapright'),
        container = map.closest('.rooms-container'),
        roomsCol = container.find('.roomlist');

    let display = jQuery('.map-switcher').prop('checked');

    if (viewport().width < 768) {
        map.css({
            display: display ? 'block' : 'none',
            position: 'static',
            right: '0px',
            top: '174px',
            width: 'calc(100vw - 32px)',
            height: 'calc(100vh - 174px)',
            zIndex: 30,
        });
        if (display)
            //$(window).scrollTop(0);
        $('body').css({ overflow: display });
        if(display) {
            roomsCol.hide();
        } else {
            roomsCol.show();
        }
        jQuery('.acf-map').css('height', 'calc(100vh - 174px');

        if (jQuery('.rooms-container').length)
            jQuery('.mobile-map-switcher').css({ display: jQuery(document).scrollTop() <= jQuery('.rooms-container').offset().top + jQuery('.rooms-container').height() - viewport().height ? 'flex' : 'none' });
    } else {
        $('body').css({ overflow: 'unset' });
        roomsCol.show();
        map.css('width', get_mapWidth() + 'px');
        jQuery('.acf-map').css('height', get_mapHeight() + 'px');

        if (get_mapTop() < jQuery(document).scrollTop()) {
            let h = container.offset().top + container.height() - viewport().height;
            h -= 431;
            if (jQuery(document).scrollTop() > h) {
                map.css({
                    display: display ? 'block' : 'none',
                    position: 'absolute',
                    top: 'auto',
                    bottom: 431,
                    right: 0
                });
            } else {
                map.css({
                    display: display ? 'block' : 'none',
                    position: 'fixed',
                    top: jQuery('#main-header').outerHeight() + 'px',
                    right: get_mapRight() + 'px'
                });
            }
        } else {
            map.css({
                display: display ? 'block' : 'none',
                position: 'inherit',
                top: 0 + 'px',
                right: 0 + 'px'
            });
        }
    }

    if (display)
        setTimeout(function () {
            $(document).trigger('mapResize');
        }, 400);
}

function mapInit() {
    mapPositioning();

    jQuery(window).on('scroll', function () {
        mapPositioning();
    });

    jQuery(window).on('resize', function () {
        mapPositioning();
    });
}

export const init = () => {
    if (!$('.acf-map').length) return;

    $('.acf-map').each(function () {
        map = initMap($(this));
    });

    $(document).on('mouseover', '.room', function () {
        let id = $(this).attr('id');

        const cluster = getClusterById(map, id);
        if (cluster && cluster.markers.length > 1) {
            cluster.marker['oldzindex'] = cluster.marker.getZIndex();
            cluster.marker.setZIndex(1001);
            const color = getClusterColor(cluster.markers);

            cluster.marker.setIcon({
                url: `data:image/svg+xml;base64,${MarkerIcon(color)}`,
                scaledSize: new google.maps.Size(58, 58),
            });
        } else {
            showme(id);
        }
    });
    $(document).on('mouseout', '.room', function () {
        let id = $(this).attr('id');

        const cluster = getClusterById(map, id);
        if (cluster && cluster.markers.length > 1) {
            cluster.marker.setZIndex(cluster.marker['oldzindex']);
            const color = getClusterColor(cluster.markers);

            cluster.marker.setIcon({
                url: `data:image/svg+xml;base64,${MarkerIcon(color)}`,
                scaledSize: new google.maps.Size(45, 45),
            });
        } else {
            showold(id);
        }
    });

    $(document).on('click', '.room .location', function () {
        let id = $(this).closest('.room').attr('id');
        map.setZoom(17);
        
        // const cluster = map.markerCluster.clusters.find((c) => typeof c.markers.find((m) => m.id === id) !== 'undefined');
        // const ids = cluster.markers.map((v) => v.id);
        
        let marker = ms[id];
        map.setCenter(new google.maps.LatLng(marker.position.lat(), marker.position.lng()))
        create_popup(map, marker, [id], id);
    });

    $("span.overs").click(function () {
        $('.search-section').hide();
    });
    $(".listing-search form").on("submit", function () {
        $('body').removeClass('loaded');
    });//submit

    $('.map-switcher').change(function () {
        const display = $('.map-switcher').prop('checked');
        localStorage.setItem('map-opened', display ? '1' : '0');
        if (display) {
            $('.roomlist').removeClass('roomlist--full');
            $(window).scrollTop(0);
            $('.mobile-map-switcher').addClass('active');
        } else {
            $('.roomlist').addClass('roomlist--full');
            $(window).scrollTop(0);
            $('.mobile-map-switcher').removeClass('active');
        }

        mapPositioning();
    });

    $('.open-filter').click(function (e) {
        e.preventDefault();
        $(this).blur();
        $('.search-section').show();
    });

    $(".close-filter").click(function (e) {
        e.preventDefault();
        $('.search-section').hide();
    });

    $('.mobile-map-switcher').click(function () {
        $('.map-switcher').click();
    });

    const currentMapOpened = $('.map-switcher').prop('checked'),
        mapOpened = localStorage.getItem('map-opened') === '1' || (viewport().width >= 768 && localStorage.getItem('map-opened') === null);
    if (currentMapOpened !== mapOpened)
        $('.map-switcher').click();
};

export const destroy = () => {
    // Remove all event listeners
    $(document).off('mapResize');
    $('.room').off('mouseover mouseout');
    $('.room').find('.location').off('click');
    $('span.overs').off('click');
    $('.listing-search form').off('submit');
    $('.map-switcher').off('change');
    $('.open-filter').off('click');
    $('.close-filter').off('click');
    $('.mobile-map-switcher').off('click');
    $(window).off('scroll resize');

    // Close info window if open
    if (map && map.infoWindow) {
        map.infoWindow.close();
        map.infoWindow = null;
    }

    // Clear marker clusterer
    if (map && map.markerCluster) {
        map.markerCluster.clearMarkers();
        map.markerCluster = null;
    }

    // Remove all markers from map
    if (map && map.markers) {
        map.markers.forEach(marker => {
            if (marker) {
                google.maps.event.clearInstanceListeners(marker);
                marker.setMap(null);
            }
        });
        map.markers = [];
    }

    // Clear global marker arrays
    markerhover = [];
    ms = [];

    // Reset map to null
    map = null;

    // Remove map elements from DOM
    $('.acf-map').empty();
};

jQuery(function ($) {
    init();
});
